import { Base } from './base.model';
import { Comentario, HasComentarios } from './comentario';
import { PlanoTrabalho } from './plano-trabalho.model';
import { HasReacoes, Reacao } from './reacao';
import { Usuario } from './usuario.model';

export class Ocorrencia extends Base implements HasReacoes, HasComentarios {
    public usuario?: Usuario;
    public plano_trabalho?: PlanoTrabalho;

    public data_inicio: Date = new Date();
    public data_fim: Date = new Date();
    public descricao: string = "";

    public usuario_id: string = "";
    public plano_trabalho_id: string | null = null;
    public reacoes: Reacao[] = []; /* Reações da ocorrencia*/
    public comentarios: Comentario[] = []; /* Comentarios da ocorrencia */

    public constructor(data?: any) { super(); this.initialization(data); }
} 